import { ObjectSchema, number, object, string } from 'yup';
import { locale } from './../yup-locale';
import * as yup from 'yup';
import { ReposeGroup, NonDigitalDataType, NonDigitalValueFlag } from './../../models/repose-group';
yup.setLocale(locale);

export const reposeGroupNameMaxLimit = 32;
export const reposeGroupDescriptionMaxLimit = 20;

export function reposeGroupValidator(): ObjectSchema<ReposeGroup> {
    return object({
        id: string().uuid().strict(),
        groupNo: number().required().nonNullable().strict(),
        vesselId: string().uuid().strict(),
        name: string().required().nonNullable().strict().max(reposeGroupNameMaxLimit),
        description: string().nullable().strict().max(reposeGroupDescriptionMaxLimit),
        channelId: string().uuid().strict(),
        setPoint: number().required().strict(),
        nonDigitalDataType: yup
            .mixed<NonDigitalDataType>()
            .oneOf(Object.values(NonDigitalDataType))
            .required()
            .strict(),
        nonDigitalValueFlag: yup
            .mixed<NonDigitalValueFlag>()
            .oneOf(Object.values(NonDigitalValueFlag))
            .required()
            .strict(),
        nonDigitalAlarm: string().required().nullable().strict(),
        digitalChannelStatus: number().required().nullable().strict(),
        startDelay: number().required().min(0).strict(),
        stopDelay: number().required().min(0).strict(),
    })
        .strict()
        .noUnknown();
}
